import React, { useEffect, useState } from "react";
import Form from "../Form";
import RolesPermissionsForm from "./RolesPermissionForm";
import { newValidationSchema, PanelData } from "./constants";
import { useLocation } from "react-router-dom";
import { storageKeys } from "../../constants/storageKeys";

const RolesPermissions = () => {
  const location = useLocation();
  const data = location.state?.roleData ?? {};

  const [rolesDetailsData, setRolesDetailsData] = useState(
    !!localStorage?.getItem(storageKeys?.ROLE_DATA_KEY)
      ? JSON.parse(localStorage?.getItem(storageKeys?.ROLE_DATA_KEY))
      : data,
  );

  useEffect(() => {
    sessionStorage.setItem(
      storageKeys.ROLE_DATA_KEY,
      location?.state?.roleData,
    );
  }, [location.state]);

  return (
    <>
      <Form
        defaultValues={{
          roleName: rolesDetailsData?.roleName ?? undefined,
          ...rolesDetailsData?.SelectedPermissions,
        }}
        validationSchema={newValidationSchema}
      >
        {() => (
          <RolesPermissionsForm
            isEdit={rolesDetailsData?.isEdit}
            PanelData={rolesDetailsData?.PanelData ?? PanelData}
            roleId={rolesDetailsData?.roleId}
          />
        )}
      </Form>
    </>
  );
};

export default RolesPermissions;
